// activityType: subtle surface tints + matching accent color per
// activity type. Drives the calendar card's background + uppercase
// eyebrow so the user can scan training vs. match vs. meeting at a
// glance without losing the team-color signal (which still owns the
// left border + dot).
//
// Tints are deliberately VERY pale ("off-white with a hint of color")
// so they don't fight the design system's "pastels are accent-only"
// rule — these read as surface variation, not as pastel fills. Accent
// color is darker / saturated, used only for the small uppercase type
// label on each card.
//
// Keep this file dependency-free; it's imported wherever an activity
// renders (calendar, activity feed, public schedule).

import type { ActivityType } from '@/api/activities';

export interface TypeTone {
  // Card background — very faint surface tint.
  bg: string;
  // Eyebrow / type-label color — saturated, paired with the bg.
  accent: string;
}

export function typeTone(t: ActivityType): TypeTone {
  switch (t) {
    case 'match':
      return { bg: '#fef2eb', accent: '#c2410c' }; // peach + burnt orange
    case 'meeting':
      return { bg: '#fbf4e3', accent: '#a16207' }; // cream + amber
    case 'cup':
      return { bg: '#f1ecfa', accent: '#6d28d9' }; // pale violet + indigo
    case 'camp':
      return { bg: '#eaf6f9', accent: '#0e7490' }; // pale aqua + teal
    case 'other':
      return { bg: '#f3f4f6', accent: '#475569' }; // pale slate + slate
    case 'training':
    default:
      return { bg: '#eef6ec', accent: '#15803d' }; // pale mint + forest
  }
}
